SingleProduct.service( 'VariationsSrv', [ '$q', 'DATA', 'CartSrv', function( $q, DATA, CartSrv ) {
	var filtered_variations = DATA.VARIATIONS,
		currents = {},
		chosen_variation = null;

	function removeDuplications( arr ) {
		var uniq = new Set();
		arr.forEach(function(e){ return  uniq.add(JSON.stringify(e)) } );
		return Array.from(uniq).map(function(e){ return JSON.parse(e) } );
	}


	return {

		basket: [],

		initCurrents: function () {
			DATA.ATTRIBUTES.forEach(function( attribute ) {
				currents[ attribute ] = null
			})
			if( DATA.HUE ) {
				currents.pa_primer = DATA.HUE.primer_slug;
				currents.pa_def_color = null
			}
		},


		setChosenVariation: function( qty ) {
			chosen_variation = filtered_variations.filter(function( variation ){
				var matches = [],
					variation_attributes = Object.values( variation.attributes ).filter(function(variation_attr){
						return variation_attr !== null && variation_attr !== '';
					});
				DATA.ATTRIBUTES.forEach(function ( key ) {
					if( currents[ key ] !== null && variation.attributes['attribute_' + key ] === currents[ key ] ) {
						matches.push(key)
					}
				})

				return matches.length === variation_attributes.length;

			})

			chosen_variation = (chosen_variation && chosen_variation.length ) ? { variation: chosen_variation[0], qty: qty } : null;
			if(chosen_variation)
				chosen_variation.price = parseFloat( chosen_variation.variation.display_price )* chosen_variation.qty

			return chosen_variation
		},

		filterVariations: function (  ) {

			var currentsToCheck = [];
			DATA.ATTRIBUTES.forEach(function(key){
				var current = {};
				if( currents [ key ] !== null ) {
					current[ key ] = currents [ key ];
					currentsToCheck.push( current )
				}
			})
			filtered_variations = DATA.VARIATIONS.filter(function( variation ){
				var match = true;

				currentsToCheck.forEach(function ( current, index ) {
					var key = Object.keys(current)[index];
					if(variation.attributes['attribute_' + key ] !== current[ key ] )
						match = false;

				})

				return match;
			})
		},

		getBoxSizes: function () {

			//If the product has both properties and one of them needs to be chosen:
			if( currents.hasOwnProperty('pa_primer') && currents.hasOwnProperty('pa_def_color') ) {
				if( currents.pa_primer === null && currents.pa_def_color === null ){
					return [];
				}
			}
			// if( currents.hasOwnProperty('pa_primer') || currents.hasOwnProperty('pa_def_color') ) {
			//
			// 	//If the product has both properties and one of them needs to be chosen:
			// 	if( currents.hasOwnProperty('pa_primer') && currents.hasOwnProperty('pa_def_color') ) {
			// 		if( currents.pa_primer === null && currents.pa_def_color === null ){
			// 			return [];
			// 		}
			// 	} else if (currents.pa_primer === null || currents.pa_def_color === null){
			// 		return [];
			// 	}
			// }

			//Filter out variations with no box size attributes
			var boxSizes = filtered_variations.filter( function( variation ) {
				return ( variation.attributes.hasOwnProperty('attribute_pa_liter') || variation.attributes.hasOwnProperty('attribute_pa_kilogram') )
			})

			//Map an object with relevant details.
			boxSizes = boxSizes.map(function( variation ) {
				var attrSizeUnit = variation.attributes.hasOwnProperty('attribute_pa_liter') ? 'attribute_pa_liter' :  'attribute_pa_kilogram',
					size = parseFloat( variation.attributes[ attrSizeUnit ] );

				return {
					value: size,
					sizeUnit: attrSizeUnit === 'attribute_pa_kilogram' ? 'ק"ג' : ( attrSizeUnit === 'attribute_pa_liter' && size < 1 ) ? 'מיל\'' : 'ליטר',
					weight: variation.weight.replace(/[^0-9\.]/g, ''),
					attrSizeUnit: attrSizeUnit
				};
			});

			boxSizes.sort(function(a, b) {
				return a.value - b.value;
			});


			return removeDuplications( boxSizes )
		},

		getFinishings: function(){
			if( currents.hasOwnProperty('pa_primer') || currents.hasOwnProperty('pa_def_color') ) {

				//If the product has both properties and one of them needs to be chosen:
				if( currents.hasOwnProperty('pa_primer') && currents.hasOwnProperty('pa_def_color') ) {
					if( currents.pa_primer === null && currents.pa_def_color === null ){
						return [];
					}
				} else if (currents.pa_primer === null || currents.pa_def_color === null){
					return [];
				}
			}
			//Filter out variations with no finishing attributes
			var finishings = filtered_variations.filter( function( variation ) {
				return ( variation.attributes.hasOwnProperty('attribute_pa_finishing') && variation.attributes.attribute_pa_finishing !== '' )
			})

			//Map an object with relevant details.
			var finishings = finishings.map(function( variation ) {

				var finishingData = DATA.FINISHINGS.filter(function ( finishing ) {
					return finishing.slug === variation.attributes.attribute_pa_finishing
				})[0]

				return {
					value: variation.attributes.attribute_pa_finishing,
					name: finishingData.name
				}
			});

			return removeDuplications( finishings );
		},

		getDefColor: function () {
			//If the product is hue-able it handles def color in this.toggleDefColor() method
			if(  currents.hasOwnProperty('pa_primer') )
				return [];


			//Filter out variations with no finishing attributes
			var defColors = filtered_variations.filter( function( variation ) {
				return ( variation.attributes.hasOwnProperty('attribute_pa_def_color') && variation.attributes.attribute_pa_def_color !== '' )
			})


			//Map an object with relevant details.
			var defColors = defColors.map(function( variation ) {

				var defColorData = DATA.DEF_COLOR.filter(function ( defColor ) {
					return defColor.slug === variation.attributes.attribute_pa_def_color
				})[0]

				return {
					value: variation.attributes.attribute_pa_def_color,
					name: defColorData.name
				}
			});


			return removeDuplications( defColors );
		},

		toggleDefColor: function ( isDefColor, color ) {
			if ( isDefColor ){
				currents.pa_def_color = color
				currents.pa_primer = null
			} else {
				currents.pa_def_color = null
				currents.pa_primer = DATA.HUE.primer_slug || null
			}
			currents[ DATA.ATTR_SIZE_UNIT ] = null
			this.filterVariations()
		},

		setBoxSize: function( package ){
			if( !package ) {
				currents[ DATA.ATTR_SIZE_UNIT ] = null
				return;
			}

			var package = JSON.parse( package )
			currents[ DATA.ATTR_SIZE_UNIT ] = package.value.toString();
		},

		setFinishing: function( finishing ) {
			if( !finishing ) {
				currents.pa_finishing = null
				// this.filterVariations();
				return;
			}

			var finishing = JSON.parse( finishing )
			currents.pa_finishing = finishing.value;
			// this.filterVariations();

			return;
		},

		setDefColor: function ( defColor ) {
			if( !defColor ) {
				currents.pa_def_color = null
				// this.filterVariations();
				return;
			}

			var defColor = JSON.parse( defColor )
			currents.pa_def_color = defColor.value;
			// this.filterVariations();

			return;
		},

		validateVariations: function () {
			if( chosen_variation || this.basket.length)
				return {result: true};

			//If this product needs to be hues or has a default color to choose:
			if( currents.hasOwnProperty('pa_primer') || currents.hasOwnProperty('pa_def_color') ) {

				//If the product has both properties and one of them needs to be chosen:
				if( currents.hasOwnProperty('pa_primer') && currents.hasOwnProperty('pa_def_color') ) {
					if( currents.pa_primer === null && currents.pa_def_color === null ){
						return {result: false, message: 'יש לבחור גוון למוצר זה על מנת להוסיפו לעגלה'};
					}
				} else if (currents.pa_primer === null || currents.pa_def_color === null){
					return {result: false, message: 'יש לבחור גוון למוצר זה על מנת להוסיפו לעגלה'};
				}
			}
			if( currents.hasOwnProperty('pa_finishing') && currents.pa_primer === null ) {
				return {result: false, message: 'יש לבחור גימור למוצר זה על מנת להוסיפו לעגלה'};
			}

			return {result: false, message: 'יש לבחור גודל אריזה למוצר זה על מנת להוסיפו לעגלה'};
		},

		addItem: function( qty ) {
			if( !chosen_variation )
				return;


			var item = {variation: chosen_variation.variation, qty: qty}
				item.price = item.variation.display_price * item.qty;

			this.basket.push( item )
			chosen_variation = null

			this.initCurrents()
		},

		addToCart: function () {
			var self = this,
				deffered = $q.defer();

			if( chosen_variation ){
				this.basket.push( chosen_variation )
			}

			var items = this.basket.map( function( item ) {
				var hue_id = ( item.variation.attributes.attribute_pa_primer !== '' && DATA.HUE ) ? DATA.HUE.ID : false
				return {
					variation_id: item.variation.variation_id,
					quantity: item.qty,
					hue_id: hue_id
				}
			})

			CartSrv.addToCart( items  ).then(
				function( status ) {
					self.basket = []
					chosen_variation = null
					self.initCurrents()
					deffered.resolve( status );
				}
			)

			return deffered.promise;
		}
	}
}])